import React, { useState } from "react";
import { ContactModal } from "../calltoactions/ContactModal";

const Slider = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="shane_tm_hero" id="home" data-style="two">
        <div className="background">
          <div
            className="image"
            style={{ backgroundImage: "url(img/slider-profile.webp)" }}
          ></div>
        </div>
        {/* End .background */}

        <div className="container">
          <div className="content">
            <span className="hero_eyebrow">משרד עורכי דין בבאר שבע</span>
            <div className="name_wrap">
              <h1>
                <span className="hero_title_outline">וידבסקי ושות׳</span>
                עורכי דין
              </h1>
            </div>
            {/* End title */}

            <div className="job_wrap">
              <span className="job">
                אנו גאים להציע שירותים משפטיים ברמה הגבוהה ביותר, עם דגש על
                מקצועיות, אמינות ומחויבות להצלחתכם. הצוות שלנו מתמחה במגוון
                רחב של תחומים משפטיים ומוכן לעמוד לשירותכם בכל עת.
              </span>
            </div>
            {/* End designation */}

            <div className="hero_actions">
              <button
                type="button"
                className="hero_btn hero_btn_primary"
                onClick={() => setIsOpen(true)}
              >
                לייעוץ ראשוני
              </button>
              <a className="hero_btn hero_btn_secondary" href="#services">
                תחומי התמחות
              </a>
            </div>

            <div className="hero_badges" aria-label="יתרונות המשרד">
              <span>ייצוג מקצועי</span>
              <span>ליווי אישי</span>
              <span>זמינות גבוהה</span>
            </div>
          </div>
          {/* End content */}

          <div className="shane_tm_down loaded">
            <div className="line_wrapper">
              <div className="line"></div>
            </div>
          </div>
        </div>
        {/* End .container */}
      </div>
      <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Slider;
